import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import History from "./pages/History";
import Result from "./pages/Result";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminReviews from "./pages/AdminReviews";
import AdminPortal from "./pages/AdminPortal";
import Team from "./pages/Team";
import JoinWorkspace from "./pages/JoinWorkspace";
import ChangePassword from "./pages/ChangePassword";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-sm text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/history" element={<Protected><History /></Protected>} />
            <Route path="/app/result/:id" element={<Protected><Result /></Protected>} />
            <Route path="/app/admin/reviews" element={<Protected><AdminReviews /></Protected>} />
            <Route path="/app/admin/portal" element={<Protected><AdminPortal /></Protected>} />
            <Route path="/app/team" element={<Protected><Team /></Protected>} />
            <Route path="/change-password" element={<Protected><ChangePassword /></Protected>} />
            <Route path="/join/:token" element={<JoinWorkspace />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
